import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { PromptExplainer } from './components/PromptExplainer/PromptExplainer';
import { VerificationChecklist } from './components/VerificationChecklist';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-ink text-fog" data-id="element-0" data-mp="28ufpyg1ohml6">
      <MetaPixel data-id="element-1" data-mp="28sl0cofgp6ar" />
      <OfferBar data-id="element-2" data-mp="28s31dk1f0dz5" />
      {/* Spacer matching the fixed offer bar height */}
      <div className="h-12" aria-hidden="true" data-id="element-3" data-mp="23v2sl1d6kx4c" />
      <main data-id="element-4" data-mp="3ikhaeg9qb525">
        <Hero data-id="element-5" data-mp="3iiwdijzxza14" />
        <Stats data-id="element-6" data-mp="3ij65gd4jrr9g" />
        <Testimonials data-id="element-7" data-mp="3ijpcuzwkmx98" />
        <PainPoints data-id="element-8" data-mp="3mlja0y7k5j4n" />
        <Volumes data-id="element-9" data-mp="3ml13n8r6loj0" />
        <Bonuses data-id="element-10" data-mp="3mkhm3t5g125i" />
        <Pricing data-id="element-11" data-mp="3mjzrt22ccy08" />
        <PromptExplainer data-id="element-12" data-mp="3mjga9mglsbmq" />
        <VerificationChecklist data-id="element-13" data-mp="3rcj5s04xxv5k" />
        <FAQ data-id="element-14" data-mp="3rdaselgk8ijp" />
        <FinalCTA data-id="element-15" data-mp="3rcsy3udgkeef" />
      </main>
      <Footer data-id="element-16" data-mp="3relvej26lm9r" />
    </div>;
}